import * as React from 'react'

export type MonthlyDataRowSelectionOverridesType = Record<string, boolean | undefined>

interface Props {
  clearInactiveIdsBlacklist?: string[]
}

export function useMonthlyDataControls({ clearInactiveIdsBlacklist }: Props) {
  const [isShowMore, setIsShowMore] = React.useState(false)
  const [monthlyDataRowSelectionOverrides, setMonthlyDataRowSelectionOverrides] =
    React.useState<MonthlyDataRowSelectionOverridesType>({})

  const toggleMonthlyDataRowSelection = React.useCallback((id: string, isSelected: boolean) => {
    setMonthlyDataRowSelectionOverrides((prevState) => ({
      ...prevState,
      [id]: isSelected,
    }))
  }, [])

  const clearInactiveMonthlyData = React.useCallback(() => {
    setMonthlyDataRowSelectionOverrides((prevState) =>
      Object.keys(prevState).reduce(
        (acc, id) =>
          clearInactiveIdsBlacklist?.includes(id)
            ? acc
            : {
                ...acc,
                [id]: prevState[id] ? true : undefined,
              },
        prevState
      )
    )
  }, [clearInactiveIdsBlacklist])

  const toggleIsShowMore = React.useCallback(
    (isShowMore: boolean) => {
      if (isShowMore) {
        clearInactiveMonthlyData()
      }
      setIsShowMore(isShowMore)
    },
    [clearInactiveMonthlyData]
  )

  return React.useMemo(
    () => ({
      monthlyDataRowSelectionOverrides,
      toggleMonthlyDataRowSelection,
      toggleIsShowMore,
      isShowMore,
    }),
    [monthlyDataRowSelectionOverrides, toggleMonthlyDataRowSelection, toggleIsShowMore, isShowMore]
  )
}
